import { render, staticRenderFns } from "./EducationHistoryList.vue?vue&type=template&id=7bef8256&scoped=true"
import script from "./EducationHistoryList.vue?vue&type=script&lang=js"
export * from "./EducationHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bef8256",
  null
  
)

export default component.exports